module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"root":"jQuery","commonjs2":"jquery","commonjs":"jquery","amd":"jquery"}
// module id = 0
// module chunks = 0 1